import {
  ENQUEUE_PUBLISH_JOB,
  REMOVE_PUBLISH_JOB,
  UPDATE_PUBLISH_JOB_PROGRESS,
  MARK_BANNER_LIST_STALE,
  CLEAR_BANNER_LIST_STALE,
  MARK_TEMPLATE_LIST_STALE,
  CLEAR_TEMPLATE_LIST_STALE,
  MARK_PAGES_LIST_STALE,
  CLEAR_PAGES_LIST_STALE,
  MARK_CATEGORIES_LIST_STALE,
  CLEAR_CATEGORIES_LIST_STALE,
  MARK_WIDGETS_LIST_STALE,
  CLEAR_WIDGETS_LIST_STALE,
  MARK_SEO_LIST_STALE,
  CLEAR_SEO_LIST_STALE,
  MARK_INFORMATION_POLICY_LIST_STALE,
  CLEAR_INFORMATION_POLICY_LIST_STALE,
  MARK_ADMIN_SETTINGS_STALE,
  CLEAR_ADMIN_SETTINGS_STALE,
  MARK_CONFIG_SETTINGS_STALE,
  CLEAR_CONFIG_SETTINGS_STALE,
  MARK_TAX_CATEGORY_LIST_STALE,
  CLEAR_TAX_CATEGORY_LIST_STALE,
  MARK_EMPLOYER_LIST_STALE,
  CLEAR_EMPLOYER_LIST_STALE,
  MARK_BRANCH_LIST_STALE,
  CLEAR_BRANCH_LIST_STALE,
  MARK_STAFF_LIST_STALE,
  CLEAR_STAFF_LIST_STALE,
  MARK_SHIFT_LIST_STALE,
  CLEAR_SHIFT_LIST_STALE,
  MARK_TRANSACTION_LIST_STALE,
  CLEAR_TRANSACTION_LIST_STALE,
  MARK_SHIFT_APPLICATION_LIST_STALE,
  CLEAR_SHIFT_APPLICATION_LIST_STALE,
  MARK_TIMESHEET_LIST_STALE,
  CLEAR_TIMESHEET_LIST_STALE,
  MARK_STAFF_DOCUMENTS_LIST_STALE,
  CLEAR_STAFF_DOCUMENTS_LIST_STALE,
  MARK_STAFF_AVAILABILITY_LIST_STALE,
  CLEAR_STAFF_AVAILABILITY_LIST_STALE,
} from '../constants/PendingPublish';
import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';

export const enqueuePublishJob = (payload) => ({
  type: ENQUEUE_PUBLISH_JOB,
  payload,
});

export const updatePublishJobProgress = (payload) => ({
  type: UPDATE_PUBLISH_JOB_PROGRESS,
  payload,
});

export const removePublishJob = (id) => ({
  type: REMOVE_PUBLISH_JOB,
  payload: id,
});

export const markBannerListStale = () => ({
  type: MARK_BANNER_LIST_STALE,
});

export const clearBannerListStale = () => ({
  type: CLEAR_BANNER_LIST_STALE,
});

export const markTemplateListStale = () => ({
  type: MARK_TEMPLATE_LIST_STALE,
});

export const clearTemplateListStale = () => ({
  type: CLEAR_TEMPLATE_LIST_STALE,
});

export const markPagesListStale = () => ({
  type: MARK_PAGES_LIST_STALE,
});

export const clearPagesListStale = () => ({
  type: CLEAR_PAGES_LIST_STALE,
});

export const markCategoriesListStale = () => ({
  type: MARK_CATEGORIES_LIST_STALE,
});

export const clearCategoriesListStale = () => ({
  type: CLEAR_CATEGORIES_LIST_STALE,
});

export const markWidgetsListStale = () => ({
  type: MARK_WIDGETS_LIST_STALE,
});

export const clearWidgetsListStale = () => ({
  type: CLEAR_WIDGETS_LIST_STALE,
});

export const markSeoListStale = () => ({
  type: MARK_SEO_LIST_STALE,
});

export const clearSeoListStale = () => ({
  type: CLEAR_SEO_LIST_STALE,
});

export const markInformationPolicyListStale = () => ({
  type: MARK_INFORMATION_POLICY_LIST_STALE,
});

export const clearInformationPolicyListStale = () => ({
  type: CLEAR_INFORMATION_POLICY_LIST_STALE,
});

export const markAdminSettingsStale = () => ({
  type: MARK_ADMIN_SETTINGS_STALE,
});

export const clearAdminSettingsStale = () => ({
  type: CLEAR_ADMIN_SETTINGS_STALE,
});

export const markConfigSettingsStale = () => ({
  type: MARK_CONFIG_SETTINGS_STALE,
});

export const clearConfigSettingsStale = () => ({
  type: CLEAR_CONFIG_SETTINGS_STALE,
});

export const markTaxCategoryListStale = () => ({
  type: MARK_TAX_CATEGORY_LIST_STALE,
});

export const clearTaxCategoryListStale = () => ({
  type: CLEAR_TAX_CATEGORY_LIST_STALE,
});

export const markEmployerListStale = () => ({
  type: MARK_EMPLOYER_LIST_STALE,
});

export const clearEmployerListStale = () => ({
  type: CLEAR_EMPLOYER_LIST_STALE,
});

export const markBranchListStale = () => ({
  type: MARK_BRANCH_LIST_STALE,
});

export const clearBranchListStale = () => ({
  type: CLEAR_BRANCH_LIST_STALE,
});

export const markStaffListStale = () => ({
  type: MARK_STAFF_LIST_STALE,
});

export const clearStaffListStale = () => ({
  type: CLEAR_STAFF_LIST_STALE,
});

export const markShiftListStale = () => ({
  type: MARK_SHIFT_LIST_STALE,
});

export const clearShiftListStale = () => ({
  type: CLEAR_SHIFT_LIST_STALE,
});

export const markTransactionListStale = () => ({
  type: MARK_TRANSACTION_LIST_STALE,
});

export const clearTransactionListStale = () => ({
  type: CLEAR_TRANSACTION_LIST_STALE,
});

export const markShiftApplicationListStale = () => ({
  type: MARK_SHIFT_APPLICATION_LIST_STALE,
});

export const clearShiftApplicationListStale = () => ({
  type: CLEAR_SHIFT_APPLICATION_LIST_STALE,
});

export const markTimesheetListStale = () => ({
  type: MARK_TIMESHEET_LIST_STALE,
});

export const clearTimesheetListStale = () => ({
  type: CLEAR_TIMESHEET_LIST_STALE,
});

export const markStaffDocumentsListStale = () => ({
  type: MARK_STAFF_DOCUMENTS_LIST_STALE,
});

export const clearStaffDocumentsListStale = () => ({
  type: CLEAR_STAFF_DOCUMENTS_LIST_STALE,
});

export const markStaffAvailabilityListStale = () => ({
  type: MARK_STAFF_AVAILABILITY_LIST_STALE,
});

export const clearStaffAvailabilityListStale = () => ({
  type: CLEAR_STAFF_AVAILABILITY_LIST_STALE,
});

export const markListStaleForContentType = (contentType) => {
  switch (contentType) {
    case PUBLISH_CONTENT_TYPES.BANNER:
      return markBannerListStale();
    case PUBLISH_CONTENT_TYPES.TEMPLATE:
      return markTemplateListStale();
    case PUBLISH_CONTENT_TYPES.PAGES:
      return markPagesListStale();
    case PUBLISH_CONTENT_TYPES.CATEGORIES:
      return markCategoriesListStale();
    case PUBLISH_CONTENT_TYPES.WIDGETS:
      return markWidgetsListStale();
    case PUBLISH_CONTENT_TYPES.SEO:
      return markSeoListStale();
    case PUBLISH_CONTENT_TYPES.INFORMATION_POLICY:
      return markInformationPolicyListStale();
    case PUBLISH_CONTENT_TYPES.ADMIN_SETTINGS:
      return markAdminSettingsStale();
    case PUBLISH_CONTENT_TYPES.CONFIG_SETTINGS:
      return markConfigSettingsStale();
    case PUBLISH_CONTENT_TYPES.TAX_CATEGORY:
      return markTaxCategoryListStale();
    case PUBLISH_CONTENT_TYPES.EMPLOYER:
      return markEmployerListStale();
    case PUBLISH_CONTENT_TYPES.BRANCH:
      return markBranchListStale();
    case PUBLISH_CONTENT_TYPES.STAFF:
      return markStaffListStale();
    case PUBLISH_CONTENT_TYPES.SHIFT:
      return markShiftListStale();
    case PUBLISH_CONTENT_TYPES.TRANSACTION:
      return markTransactionListStale();
    case PUBLISH_CONTENT_TYPES.SHIFT_APPLICATION:
      return markShiftApplicationListStale();
    case PUBLISH_CONTENT_TYPES.TIMESHEET:
      return markTimesheetListStale();
    case PUBLISH_CONTENT_TYPES.STAFF_DOCUMENTS:
      return markStaffDocumentsListStale();
    case PUBLISH_CONTENT_TYPES.STAFF_AVAILABILITY:
      return markStaffAvailabilityListStale();
    default:
      return { type: 'NOOP' };
  }
};
